export default __webpack_public_path__ + "static/service-custom-7adbf9b1348ef187f7acbc54be0a844d.png";